export default {
    title: 'Dashboard',
    error: {
        title: 'No ha sido posible cargar el dashboard',
        detail: 'Detalle',
        action: 'Por favor, inténtelo de nuevo.'
    }
}